import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { recentAccidentsColumns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const RecentAccidents = ({ recentAccidents, i18n, viewReport }) => {
  const generateRows = () => {
    const updatedList = recentAccidents?.map((item) => {
      var result = {};
      result.fullName = item.items[0];
      result.phone = item.items[1];
      result.report = (
        <a
          onClick={() =>
            viewReport({
              apiId: 'viewReportApi',
              data: item.link?.replace('./document/open/', ''),
            })
          }
          className="viewReport viewReportNewTab"
          target="_blank"
        >
          {i18n.t('accidents.viewReport')}
        </a>
      );
      return result;
    });
    return updatedList;
  };

  return (
    <>
      <Table
        type="client"
        title=""
        columns={recentAccidentsColumns}
        data={generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={10}
        actions={[]}
        i18n={i18n}
        noPagination
      />
    </>
  );
};

export default RecentAccidents;

RecentAccidents.defaultProps = {};

RecentAccidents.propTypes = {
  recentAccidents: PropTypes.array.isRequired,
};
